import { PLATFORM_IDS, type PlatformId } from "../types";

export interface PlatformInfo {
  id: PlatformId;
  label: string;
  hint: string;
}

export const PLATFORMS: PlatformInfo[] = [
  { id: "xiaohongshu", label: "小红书", hint: "个人号没有官方数据接口，请手动录入或导入。" },
  { id: "douyin", label: "抖音", hint: "个人号没有官方数据接口，请手动录入或导入。" },
  { id: "x", label: "X", hint: "公开指标适配器预留，当前仍是手动录入。" },
  { id: "instagram", label: "Instagram", hint: "请手动录入或导入。" },
];

const ALIASES: Record<string, PlatformId> = {
  小红书: "xiaohongshu",
  红书: "xiaohongshu",
  xhs: "xiaohongshu",
  xiaohongshu: "xiaohongshu",
  抖音: "douyin",
  douyin: "douyin",
  tiktok: "douyin",
  x: "x",
  twitter: "x",
  推特: "x",
  instagram: "instagram",
  ins: "instagram",
  ig: "instagram",
};

export function parsePlatform(value: string | null | undefined): PlatformId | null {
  if (!value) return null;
  const key = value.trim().toLowerCase();
  return ALIASES[key] ?? ALIASES[value.trim()] ?? null;
}

export function isPlatformId(value: string): value is PlatformId {
  return (PLATFORM_IDS as readonly string[]).includes(value);
}

export function platformLabel(id: PlatformId): string {
  return PLATFORMS.find((item) => item.id === id)?.label ?? id;
}

export function platformLabels(names: string[]): string[] {
  const labels: string[] = [];
  for (const name of names) {
    const id = parsePlatform(name);
    const label = id ? platformLabel(id) : name.trim();
    if (label && !labels.includes(label)) labels.push(label);
  }
  return labels;
}
